import gql from 'graphql-tag';

import type { EntityComplianceData } from 'src/data/compliance';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_LONG_FORM_DRAFT_COMPLIANCE } from './schema';

const QUERY = gql`
  query ComplianceForLongFormDraft($id: ID!) {
    complianceForLongFormDraft(id: $id) {
      ...LongFormDraftCompliance
    }
  }
  ${FRAGMENT_LONG_FORM_DRAFT_COMPLIANCE}
`;

export const queryComplianceForLongFormDraft = async (id: ID) => {
  const variables = { id };

  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<EntityComplianceData>(result.data);
};
